import React from 'react'


const Caraousel = () => {
  return (
    <section className="homepage homepage__hero text-center carousel slide"
        data-ride="carousel" data-interval={6500} data-pause="false" aria-hidden="true">
        <div className="carousel-inner">
          <div className="carousel-item active homepage__hero__slide homepage__hero__slide--beautiful">
            <img src={require('../_assets/image/carousel/slide_1-bg.jpg')} className='homepage__hero__image homepage__hero__image--layer-1' />
            <img src={require('../_assets/image/carousel/slide_1-layer_1.png')} className='homepage__hero__image homepage__hero__image--layer-2' />
            <h1 className="homepage__hero__text">Drag Drop <span className="color-white">Edit</span> Deploy</h1>
            <img src={require('../_assets/image/carousel/phone_bezel.png')} className='homepage__hero__phone-bezel' />
          </div>
          <div className="carousel-item homepage__hero__slide homepage__hero__slide--productive">
            <img src={require('../_assets/image/carousel/slide_2-bg.png')} className='homepage__hero__image homepage__hero__image--layer-1' />
            <img src={require('../_assets/image/carousel/slide_3-layer_2.png')} className='homepage__hero__image homepage__hero__image--layer-2' />
            <h1 className="homepage__hero__text">Target <span className="color-white">mobile, web, & desktop</span> apps</h1>
            <img src={require('../_assets/image/carousel/phone_bezel.png')} className='homepage__hero__phone-bezel' />
          </div>
          <div className="carousel-item   homepage__hero__slide homepage__hero__slide--faster">
            <img src={require('../_assets/image/carousel/slide_3-bg.png')} className='homepage__hero__image homepage__hero__image--layer-1' />
            <img src={require('../_assets/image/carousel/slide_1-layer_1.png')} className='homepage__hero__image homepage__hero__image--layer-2' />
            <h1 className="homepage__hero__text">Create <span className="color-white">enterprise-grade</span> applications</h1>
            <img src={require('../_assets/image/carousel/phone_bezel.png')} className='homepage__hero__phone-bezel' />
          </div>
          {/* <div className="carousel-item homepage__hero__slide homepage__hero__slide--publish">
            <img src={require('../_assets/image/carousel/slide_4-bg.jpg')} className='homepage__hero__image homepage__hero__image--layer-1' />
            <img src={require('../_assets/image/carousel/slide_4-layer_1.png')} className='homepage__hero__image homepage__hero__image--layer-2' />
            <img src={require('../_assets/image/carousel/slide_4-layer_2.png')} className='homepage__hero__image homepage__hero__image--layer-3' />
            <h1 className="homepage__hero__text">Target <span className="color-white">mobile, web, & desktop</span> apps</h1>
            <img src={require('../_assets/image/carousel/phone_bezel.png')} className='homepage__hero__phone-bezel' />
          </div> */}
        </div>
      </section>
  )
}

export default Caraousel;
